// Print and export for the overview and every technical view.
//
// Print: the section itself, not the app around it. The target gets a class,
// the body another, and the print stylesheet in glance.css hides everything
// else, lets scrolling tables run to full height and keeps SVGs on the page.
// Export: an authenticated download of what the server built (Excel, CSV).
import { url, tokenRef } from "api";

export function printElement(el, title) {
  if (!el || typeof window === "undefined") return;
  const previousTitle = document.title;
  el.classList.add("bl-print-target");
  document.body.classList.add("bl-printing");
  if (title) document.title = title;
  const done = () => {
    el.classList.remove("bl-print-target");
    document.body.classList.remove("bl-printing");
    document.title = previousTitle;
    window.removeEventListener("afterprint", done);
  };
  window.addEventListener("afterprint", done);
  // Some browsers never fire afterprint when the dialog is cancelled.
  setTimeout(() => { if (document.body.classList.contains("bl-printing")) done(); }, 60000);
  window.print();
}

export async function downloadAuthed(path, fileName) {
  const r = await fetch(`${url}${path}`, { headers: { Authorization: `Bearer ${localStorage.getItem(tokenRef)}` } });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error(body.err || `HTTP ${r.status}`);
  }
  const blob = await r.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  // The server names the file with the project prefix ("SPX-…"); ours is the fallback.
  a.download = (((r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/) || [])[1]) || fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
